module.exports = __webpack_public_path__ + "static/media/error500.e0581c9a.png";